import { render } from "./403.vue?vue&type=template&id=b7d79f0c&scoped=true&ts=true"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"

import "./403.vue?vue&type=style&index=0&id=b7d79f0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d79f0c"]])

export default __exports__